import { Status } from "entities/broadcasts/types";
import {
  COLOR_BLUE,
  COLOR_GREEN,
  COLOR_GREY_3,
  COLOR_YELLOW,
} from "shared/theme/colors";

export const chipColorMap: Record<Status, string> = {
  [Status.Sent]: COLOR_GREEN,
  [Status.Failed]: COLOR_YELLOW,
  [Status.Scheduled]: COLOR_BLUE,
  [Status.Draft]: COLOR_GREY_3,
};

export const chipTitleMap: Record<Status, string> = {
  [Status.Sent]: Status.Sent,
  [Status.Failed]: Status.Failed,
  [Status.Scheduled]: Status.Scheduled,
  [Status.Draft]: Status.Draft,
};
